import { IApplicationState } from '../../types/redux';

export const selectRegionId = (state: IApplicationState) => {
  return state.regionId;
};
